import { autoinject, bindable, bindingMode, computedFrom, containerless, customElement } from "aurelia-framework";
import { IInput, IListInput, IOptionsInput, IScoreTableInput } from "../../../../interfaces/form-builder/i-input";
import { ILookupAndCopyBehavior } from "../../../../interfaces/form-builder/i-behavior";
import nameof from "../../../../common/nameof";
import { NoteDataManager } from "../../note-data-manager";
import { PermissionManager } from "../../../../common/utilities/permission-manager";
import { AdministrativePermissionEnum } from "../../../../enums/administrative-permission-enum";
import { PermissionActionEnum } from "../../../../enums/permission-action-enum";
import { IAncestorSettings } from "../../../../interfaces/form-builder/i-input-options";

export enum IComponentHolderType {
    LookupAndCopy = "lookupandcopy"
}

@customElement("component-holder")
@containerless
@autoinject
export class ComponentHolder {
    @bindable({ defaultBindingMode: bindingMode.toView })
    public patientId: string;
    @bindable({ defaultBindingMode: bindingMode.toView })
    public element: IInput | IScoreTableInput | IListInput | IOptionsInput;
    @bindable({ defaultBindingMode: bindingMode.toView })
    public ancestorSettings: IAncestorSettings;
    private _permissionManager: PermissionManager;
    public lookupAndCopyBehavior: ILookupAndCopyBehavior = null;
    public noteId: string;
    public hasViewPermission: boolean = false;
    public hasEditPermission: boolean = false;

    @computedFrom(nameof<ComponentHolder>("lookupAndCopyBehavior"))
    public get isSectionTable() {
        return this.lookupAndCopyBehavior?.component?.length == 1;
    }

    public constructor(noteDataManager: NoteDataManager, permissionManager: PermissionManager) {
        this._permissionManager = permissionManager;
        this.noteId = noteDataManager.getNoteId();
    }

    public attached() {
        this.initPermissions();
        this.element.behaviors.forEach((behavior) => {
            switch (behavior.behaviorType) {
                case IComponentHolderType.LookupAndCopy:
                    this.lookupAndCopyBehavior = behavior as ILookupAndCopyBehavior;
                    return;
            }
        });
    }

    private initPermissions() {
        this.hasViewPermission = this._permissionManager.checkPermission([
            {
                resource: AdministrativePermissionEnum.HopeExportManager,
                action: PermissionActionEnum.View
            }
        ]);

        this.hasEditPermission = this._permissionManager.checkPermission([
            {
                resource: AdministrativePermissionEnum.HopeExportManager,
                action: PermissionActionEnum.Edit
            }
        ]);
    }
}
